import { render } from "./Home.vue?vue&type=template&id=50b1a482&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=50b1a482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b1a482"]])

export default __exports__